import React from 'react';

import SolutionsSec from 'sections/common/Solutions';

const Solutions = ({ data }) => {
  return <SolutionsSec data={data} />;
};

export default Solutions;
